import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Summer/Statistics/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Statistics',
  weeks: [7, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Statistics/1MakeTallyCharts" */ './1MakeTallyCharts'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () => import(/* webpackChunkName: "Year2/Summer/Statistics/2Tables" */ './2Tables')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year2/Summer/Statistics/3BlockDiagrams" */ './3BlockDiagrams')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Statistics/4DrawPictograms1To1" */ './4DrawPictograms1To1'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Statistics/5InterpretPictograms1To1" */ './5InterpretPictograms1To1'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Statistics/6DrawPictograms25And10" */ './6DrawPictograms25And10'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/Statistics/7InterpretPictograms25And10" */ './7InterpretPictograms25And10'
        )
    })
  ]
});
export default Block;
